// @flow
import * as React from 'react';
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { ListItem } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import CircleIcon from '@mui/icons-material/Circle';
import { Trans } from "react-i18next";
import { scanInfo } from "../../../../../../helpers/info";
import { EXHIBITOR_PROFILE } from "../../../../../../locales/components/namespaces";

type Props = {};
const ScanInfo = (props: Props) => {
	return (
		<Box sx={{ width: '100%', minWidth: '300px', bgcolor: 'background.paper' }}>
			<List>
				{scanInfo.map((item, index) => (
					<ListItem
						key={index}
						disablePadding
						sx={{ alignItems: 'baseline', borderBottom: '1px solid #bdbdbd' }}
					>
						<ListItemIcon sx={{
							minWidth: '20px'
						}}>
							<CircleIcon
								sx={{
									fontSize: '10px',
									minWidth: '20px'
								}}
							/>
						</ListItemIcon>
						<ListItemText>
							<Trans
								i18nKey={item}
								ns={EXHIBITOR_PROFILE}
							/>
						</ListItemText>
					</ListItem>
				))}
			</List>
		</Box>
	);
};

export default ScanInfo